<template>
	<div class="common-warapper">
		<div class="content">
			<div class="common-title">
				常见问题
			</div>
		</div>

		<div class="tab-container">
			<div class="tabs main">
				<div v-for="(tab, index) in menus" :key="index" :class="{ 'active': activeTab === tab }" class="items"
					@click="changeTab(tab.title)">
					<div :class="{ 'active-text': activeTab === tab }" class="tab-title">{{ tab.title }}</div>
					<div class="active-indicator" v-if="activeTab === tab.title"></div>
				</div>
			</div>
			<div class="tab-border"></div>
			<div class="tab-content main">
				<CommonProblem :list="list"></CommonProblem>
			</div>
		</div>
		<div class="main">
			<div class="contact-info">
				<div class="question">还有更多问题吗？</div>
				<div class="welcome-message">欢迎联络 LOOPSHOP 专员寻求协助。</div>

				<router-link to="/consultation">
					<div class="reservation-button">立即预约</div>
				</router-link>
			</div>
		</div>
		<AdBox></AdBox>
		<Start></Start>
	</div>
</template>
  
<script>
import Start from '@/components/Start.vue'
import AdBox from '@/components/AdBox.vue'
import CommonProblem from '@/components/CommonProblem.vue'
export default {
	components: { Start, AdBox, CommonProblem },
	data() {
		return {
			activeTab: '',
			menus: [],
			list: []
		}
	},
	methods: {
		changeTab(tab) {
			this.activeTab = tab;
			console.log(tab)
			
			this.list = this.menus.reduce((arr, item) => {
				item.title === tab && (arr = item.submenu)
				return arr
			}, [])
			console.log(this.list)
		},
		async getList() {
			let fdata = { do: 'questionlist', sjk: 'questionlist', orderby: 'id asc', limit: 15 }
			let res = await this.$api.funk(fdata)
			this.menus = res
			if (res && res.length) {
				this.activeTab = res[0].title
				this.list = res[0].submenu
			}
		},
	},
	created(option) {
		this.getList()
	}
}
</script>
  
<style lang="scss" scoped>
.common-warapper {
	.content {
		width: 100%;
		background: url("~@/assets/images/commerceClassroom-bgs.png") no-repeat center center / 100% 100%;
		position: relative;
		height: 3.5rem;
		display: flex;
		justify-content: center;
		align-items: center;

		.common-title {
			font-family: 'Microsoft YaHei';
			font-style: normal;
			font-weight: 600;
			font-size: 0.56rem;
			letter-spacing: 0.05em;
			text-align: center;
			color: #000000;
		}
	}

	.tab-container {
		.tabs {
			display: flex;
			justify-content: center;

			.tab-title {
				width: 3.17rem;
				cursor: pointer;
				position: relative;
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				text-align: center;
				color: #808080;
				margin: 0.16rem 0rem;
			}

			.active {
				color: red;
			}

			.active-text {
				color: red;
			}

			.active-indicator {
				height: 0.08rem;
				background: #E02E43;
				transform: matrix(1, 0, 0, -1, 0, 0);
				position: relative;
				top: 0.01rem;
				z-index: 1;
			}
		}

		.tab-border {
			height: 0.02rem;
			background: #D9D9D9;
			transform: matrix(1, 0, 0, -1, 0, 0);
		}

		.tab-content {
			margin-top: 0.8rem;

			.section-border {
				height: 0.02rem;
				background-color: #0BD9D5;
			}

			.info-section {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0.32rem 0.4rem;

				.title {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.32rem;
					color: #000000;
					line-height: 0.32rem;
				}

				.image {
					line-height: 0.2rem;
					width: 0.32rem;
					height: 0.32rem;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.content-section {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				color: #000000;
				padding: 0rem 0.4rem 0.2rem 0.4rem
			}
		}
	}



	.contact-info {
		background: #E02E43;
		border: 1px solid #FFFFFF;
		border-radius: 0.4rem;
		padding: 0.8rem 0rem 0.56rem 0rem;
		margin-top: 0.8rem;
		text-align: center;
		color: #FFFFFF;
		font-family: 'Microsoft YaHei';
		font-style: normal;

		.question {
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			margin-bottom: 0.16rem;
		}

		.welcome-message {
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			margin-bottom: 0.4rem;
		}

		.reservation-button {
			width: 2.56rem;
			background: #FFFFFF;
			border-radius: 0.08rem;
			font-weight: 600;
			font-size: 0.24rem;
			line-height: 0.32rem;
			margin: 0 auto;
			color: #000000;
			padding: 0.16rem 0rem;
			cursor: pointer;
		}
	}

	.tab-buttons {
		.active {
			.active-tab-line {
				transform: translateX(0);
			}
		}
	}
}

@media (max-width: 750px) {
	.common-warapper .tab-container .tabs {
		width: 100%;
	}

	.tab-container {
		width: 100%;

	}

	.tabs .items {
		flex: 1;
	}

	.common-warapper .tab-container .tabs .tab-title {
		width: 100%;
		padding: 0 .13rem;
	}

	.common-warapper .contact-info .reservation-button {
		width: 2.8rem;
		font-size: 0.32rem;
		line-height: 0.32rem;
		padding: 0.26rem 0rem;
	}

	.common-warapper .contact-info .welcome-message {
		margin-bottom: 0.8rem;
	}


}
</style>
  